module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "file_014"
    }
  }, [_c('em', [_vm._v("MAKING ENDS MEET")])])]), _c('a', {
    attrs: {
      "id": "file_014"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Grumman Aircraft began operations on January 2, 1930. It was terrible timing. The Wall Street stock market crash had occurred a little over two months before. No one, it seemed, could afford the new airplanes that Leroy Grumman was hoping to build.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b86d8ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_014.vue
// module id = 93
// module chunks = 0